module.exports = __webpack_public_path__ + "static/media/loading.ff925b96.svg";